/**
 * Partner filters for the locations archive grid.
 *
 * @package WPSCT
 */

export class LocationArchiveFilters {
  constructor() {
    this.init();
  }

  init() {
    const section = document.querySelector(".wps-insidepage-location-archive");

    if (!section) {
      return;
    }

    const cards = section.querySelectorAll(".location-card");
    const partnerButtons = section.querySelectorAll(
      ".filter-group--partners .filter-btn[data-partner]",
    );
    const visibleCountEl = section.querySelector("[data-locations-visible]");

    if (!cards.length) {
      return;
    }

    let activePartner = "all";

    const updateCount = () => {
      if (!visibleCountEl) {
        return;
      }

      const visible = section.querySelectorAll(
        ".location-card:not(.hidden)",
      ).length;

      visibleCountEl.textContent = String(visible);
    };

    const updateRegions = () => {
      const regions = section.querySelectorAll(".location-region");

      regions.forEach((region) => {
        const hasVisibleCards = [
          ...region.querySelectorAll(".location-card"),
        ].some((card) => !card.classList.contains("hidden"));

        region.classList.toggle("hidden", !hasVisibleCards);
      });
    };

    const filterCards = () => {
      cards.forEach((card) => {
        const cardPartner = card.dataset.partner || "";

        const partnerMatch =
          activePartner === "all" || cardPartner === activePartner;

        card.classList.toggle("hidden", !partnerMatch);
      });

      updateCount();
      updateRegions();
    };

    partnerButtons.forEach((button) => {
      button.addEventListener("click", () => {
        partnerButtons.forEach((btn) => btn.classList.remove("active"));

        button.classList.add("active");

        activePartner = button.dataset.partner || "all";

        filterCards();
      });
    });

    filterCards();
  }
}
